import { UserLanguageType } from "@Components/Modules/Helpers";

export default {
    AboutUs: "About goodie",
    Contact: "Contact",
    Copyright: `${new Date().getFullYear()} © Millennium Goodie Sp. z o.o.  All rights reserved`,
    ForPartners: "goodie for Business",
    Help: "Help",
    PrivacyPolicy: "Privacy policy",
    PrivacySettings: "Privacy settings",
    Rules: "Terms and conditions",
    SitemapIndex: "Site map",
    Accessibility: "Accessibility statement",
    GoodieDescription:
        "<b>goodie</b> is a free, modern and friendly mobile app and online platform, where you will always find the latest promo codes, flyers from your favorite stores, attractive cashback offers, discounts, promotions and sales. The goodie app will also help you with shopping by offering shopping lists, loyalty programs and commercial services. goodie - a smart way for shopping!",
    languageId: UserLanguageType.English,
};
